/**
 * Bilingual copy for the Blog article page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  layoutTitleSuffix: 'AKAS Blogs',
  fallbackDescription: 'Learn more about AKAS cloud-based business ERP solutions.',
  loading: 'Loading article...',
  notFoundTitle: "This page isn't available",
  notFoundBody:
    "The link may be broken, or the page may have been removed. Check to see if the link you're trying to open is correct.",
  backToBlog: 'Back to blog',
  backToBlogs: 'Back to blogs',
  byAuthor: 'By',
  readMore: 'Read more articles',
};

export type Copy = typeof en;

export const km: Copy = {
  layoutTitleSuffix: 'ប្លុក AKAS',
  fallbackDescription: 'ស្វែងយល់បន្ថែមអំពីដំណោះស្រាយ AKAS Cloud ERP សម្រាប់អាជីវកម្ម។',
  loading: 'កំពុងផ្ទុកអត្ថបទ...',
  notFoundTitle: 'ទំព័រនេះមិនអាចប្រើបានទេ',
  notFoundBody:
    'តំណអាចខូច ឬទំព័រអាចត្រូវបានដកចេញ។ សូមពិនិត្យថាតំណដែលអ្នកកំពុងព្យាយាមបើកគឺត្រឹមត្រូវ។',
  backToBlog: 'ត្រឡប់ទៅទំព័រប្លុកវិញ',
  backToBlogs: 'ត្រឡប់ទៅប្លុកទាំងអស់វិញ',
  byAuthor: 'ដោយ',
  readMore: 'អានអត្ថបទបន្ថែមទៀត',
};
